import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";

const PRIVACY_ITEMS = ["ownership", "control", "clarity", "selfHostable"] as const;

export function PrivacySection() {
  const { t } = useTranslation("landing");

  return (
    <section
      className="bg-muted/40 py-20 sm:py-24 lg:py-28"
      aria-labelledby="privacy-heading"
    >
      <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-primary text-primary-foreground shadow-lg">
          <ShieldCheck className="h-8 w-8" aria-hidden="true" />
        </div>
        <h2
          id="privacy-heading"
          className="mt-6 font-serif text-4xl font-semibold leading-[1.1] tracking-[-0.04em] text-foreground sm:text-5xl lg:text-6xl"
        >
          {t("privacy.heading")}
        </h2>
        <p className="mx-auto mt-5 max-w-3xl text-lg leading-8 text-muted-foreground">
          {t("privacy.subheading")}
        </p>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {PRIVACY_ITEMS.map((item) => (
            <div
              key={item}
              className="rounded-2xl border border-border bg-card p-6 text-start shadow-sm transition-shadow hover:shadow-md"
            >
              <h3 className="font-semibold text-foreground">
                {t(`privacy.items.${item}.title`)}
              </h3>
              <p className="mt-2 text-sm leading-6 text-muted-foreground">
                {t(`privacy.items.${item}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PrivacySection;
